/* ==========================================================================
   PERIOD 5.0, «Fragen und Antworten» der Kategorie (sections/period5-faq.liquid), Stand 29.10.2026 (P09).
   1. Tracking: beim Öffnen einer Frage faq_open über window.P5.track (assets/period5-events.js, nicht geändert),
      Name/Label aus data-p5-track/data-p5-label am summary, dazu der Kollektions-Handle aus der URL.
      Auf Klick statt auf «toggle»: Chrome feuert für <details open> (erste Frage offen) schon beim Laden ein toggle,
      das wäre ein Phantom-Event. Tastatur (Enter/Space auf summary) löst ebenfalls ein click-Event aus.
   2. «Nur eine Frage gleichzeitig offen» nur bei data-p5-single-open am Section-Wrapper (Setting single_open).
   Reine Verbesserung: ohne Skript bleibt das Akkordeon nativ (details/summary) bedienbar.
   ========================================================================== */
(function () {
  'use strict';
  if (window.P5Faq) return;
  window.P5Faq = true;

  var track = function (name, payload) {
    if (window.P5 && window.P5.track) window.P5.track(name, payload);
  };
  var collectionHandle = function () {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : undefined;
  };

  /* click kommt vor dem Umschalten, !details.open heisst «wird gerade geöffnet» */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('[data-p5-section="faq"] .p5-faq__summary');
    if (!summary) return;
    var details = summary.closest('details');
    if (!details || details.open) return;
    track(summary.dataset.p5Track || 'faq_open', {
      label: summary.dataset.p5Label || summary.textContent.trim().slice(0, 80),
      collection: collectionHandle()
    });
  });

  /* Eins offen: «toggle» bubbelt nicht, darum Capture-Phase auf document */
  document.addEventListener(
    'toggle',
    function (e) {
      var opened = e.target;
      if (!opened || opened.tagName !== 'DETAILS' || !opened.open) return;
      var root = opened.closest('[data-p5-section="faq"][data-p5-single-open]');
      if (!root) return;
      var items = root.querySelectorAll('details.p5-faq__item[open]');
      for (var i = 0; i < items.length; i++) {
        if (items[i] !== opened) items[i].open = false;
      }
    },
    true
  );
})();
